export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11023.ddad2c11.jpg";